<template>
  <div id="returnOrderDetail">
    <!-- 详情 -->
    <div class="titlee" v-if="type == 0">
      {{ returnOrderDetail.customerName }} |
      <!-- {{ returnOrderDetail.customerPhone }} | -->
      {{ returnOrderDetail.rental }}元/月
    </div>
    <div class="content nowarp" v-if="type == 0">
      <div class="inlineB">
        <p class="colorC l">退租类型</p>
        <p class="l">{{ quitTypeList[returnOrderDetail.quitType - 1] }}</p>
      </div>
      <div class="inlineB">
        <p class="colorC l">退租日期</p>
        <p class="l">
          {{
            returnOrderDetail.quitDate
              ? returnOrderDetail.quitDate.slice(0, 10)
              : ""
          }}
        </p>
      </div>
      <div class="inlineB">
        <p class="colorC l">当前状态</p>
        <p class="l">
          {{ returnOrderStatus[returnOrderDetail.returnOrderStatus - 1] }}
        </p>
      </div>
       <!-- <div class="inlineB">
        <p class="colorC l">签署状态</p>
        <p class="l">
          {{ returnOrderDetail.caStatus?caStatusList[returnOrderDetail.caStatus - 1]:'未签署' }}
        </p>
      </div> -->
    </div>
    <van-tabs v-model="active" class="tabs" v-if="type == 0">
      <van-tab title="基本信息">
        <!-- <div class="title">
          <i class="iconfont iconbookmark"></i> 基本信息
        </div>-->
        <van-cell title="编码" :value="returnOrderDetail.number" />
         <van-cell title="签署状态" :value="returnOrderDetail.caStatus?caStatusList[returnOrderDetail.caStatus - 1]:'未签署'" />
        <van-cell
          title="收款类型"
          :value="payTypeList[returnOrderDetail.payType - 1]"
        />
        <!-- <div class="title">
          <i class="iconfont iconbookmark"></i> 房源信息
        </div>-->
        <van-cell title="收款账号" :value="returnOrderDetail.bankAccount" />
        <van-cell title="收款人姓名" :value="returnOrderDetail.accountName" />
        <van-cell
          v-if="returnOrderDetail.payType == 3"
          title="开户行"
          :value="returnOrderDetail.bankName"
        />
        <van-cell
          v-if="returnOrderDetail.payType == 3"
          title="支行名称"
          :value="returnOrderDetail.bankBranchName"
        />
        <!-- <div class="title">
          <i class="iconfont iconbookmark"></i> 租客信息
        </div>-->
        <van-cell title="房源编码" :value="returnOrderDetail.houseNumber" />
        <van-cell
          title="地址"
          :value="
            returnOrderDetail.roomNo
              ? returnOrderDetail.houseAddress + returnOrderDetail.roomNo
              : returnOrderDetail.houseAddress
          "
        />
        <van-cell title="合约编码" :value="returnOrderDetail.contractNumber" />
        <!-- <div class="title">
          <i class="iconfont iconbookmark"></i> 签约信息
        </div>-->
        <van-cell
          title="开始日期"
          :value="
            returnOrderDetail.startDate
              ? returnOrderDetail.startDate.slice(0, 10)
              : ''
          "
        />
        <van-cell
          title="租期"
          :value="
            returnOrderDetail.leaseMonth
              ? returnOrderDetail.leaseMonth + '月'
              : '' + returnOrderDetail.leaseDay
              ? returnOrderDetail.leaseDay + '天'
              : ''
          "
        />
        <van-cell
          title="结束日期"
          :value="
            returnOrderDetail.endDate
              ? returnOrderDetail.endDate.slice(0, 10)
              : ''
          "
        />
        <van-cell
          title="支付方式"
          :value="
            returnOrderDetail.payMonth == '999'
              ? '全额付'
              : '付' +
                returnOrderDetail.payMonth +
                '押' +
                returnOrderDetail.depositMonth
          "
        />
        <van-cell title="租金" :value="returnOrderDetail.rental" />
        <van-cell title="押金" :value="returnOrderDetail.deposit" />
        <van-cell title="定金" :value="returnOrderDetail.amount" />
        <van-cell title="水电燃预交费" :value="returnOrderDetail.advanceFee" />
        <van-cell title="服务费" :value="returnOrderDetail.serviceFee" />
        <van-cell title="物业费" :value="returnOrderDetail.condoFee" />
        <van-cell title="创建人" :value="returnOrderDetail.creator" />
        <van-cell title="创建日期" :value="returnOrderDetail.createDate" />
        <van-cell
          title="备注"
          :value="returnOrderDetail.returnOrderImage.remark"
        />
        <div class="title">
          <i class="iconfont iconbookmark"></i> 一次性费用
        </div>
        <van-cell
          v-for="item in returnOrderDetail.singleMatterList"
          :key="item.id"
          :title="item.matterName"
          :value="item.amount"
        />
        <div class="title">
          <i class="iconfont iconbookmark"></i> 周期性费用
        </div>
        <van-cell
          v-for="item in returnOrderDetail.periodMatterList"
          :key="item.id"
          :title="item.matterName"
          :value="item.amount"
        />
      </van-tab>
      <van-tab title="水电燃信息">
        <div v-if="returnOrderDetail.returnOrderImage.electricMax">
          <div class="imgBody imgBody1">
            <div class="imgCard">
              <div class="text">电峰</div>
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [returnOrderDetail.returnOrderImage.electricMax];
                "
              >
                <van-image
                  width="3rem"
                  height="3rem"
                  :src="returnOrderDetail.returnOrderImage.electricMax"
                />
              </div>
              <div class="text">{{ returnOrderDetail.electricMax }}</div>
            </div>
            <div class="imgCard">
              <div class="text">电谷</div>
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [returnOrderDetail.returnOrderImage.electricMin];
                "
              >
                <van-image
                  width="3rem"
                  height="3rem"
                  :src="returnOrderDetail.returnOrderImage.electricMin"
                />
              </div>
              <div class="text">{{ returnOrderDetail.electricMin }}</div>
            </div>
            <div class="imgCard">
              <div class="text">电总</div>
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [returnOrderDetail.returnOrderImage.electricTotal];
                "
              >
                <van-image
                  width="3rem"
                  height="3rem"
                  :src="returnOrderDetail.returnOrderImage.electricTotal"
                />
              </div>
              <div class="text">{{ returnOrderDetail.electricTotal }}</div>
            </div>
          </div>
        </div>
        <div v-if="returnOrderDetail.returnOrderImage.electricMax">
          <div class="imgBody">
            <div class="imgCard">
              <div class="text">水</div>
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [returnOrderDetail.returnOrderImage.water];
                "
              >
                <van-image
                  width="3rem"
                  height="3rem"
                  :src="returnOrderDetail.returnOrderImage.water"
                />
              </div>
              <div class="text">{{ returnOrderDetail.water }}</div>
            </div>
          </div>
          <div class="imgBody">
            <div class="imgCard">
              <div class="text">燃气</div>
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [returnOrderDetail.returnOrderImage.gas];
                "
              >
                <van-image
                  width="3rem"
                  height="3rem"
                  :src="returnOrderDetail.returnOrderImage.gas"
                />
              </div>
              <div class="text">{{ returnOrderDetail.gas }}</div>
            </div>
          </div>
          <div class="imgBody other">
            <div
              class="imgCard"
              v-for="(item, index) in returnOrderDetail.otherList"
              :key="index"
            >
              <div v-if="index == 0" class="text">其它</div>
              <div v-else class="text">.</div>
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = index;
                  images = returnOrderDetail.otherList;
                "
              >
                <van-image width="3rem" height="3rem" :src="item" />
              </div>
            </div>
          </div>
        </div>
        <van-empty v-else description="暂无数据" />
      </van-tab>
      <van-tab title="退租事项">
        <div class="form3">
          <div class="card">
            <div class="title">应收事项</div>
            <table class="table">
              <tr class="head">
                <td>费用类型</td>
                <td>金额</td>
                <td>生成方式</td>
                <td>
                  <span>操作</span>
                </td>
              </tr>
              <tr
                v-for="(item, index) in returnOrderDetail.receivableOrderItems"
                :key="index"
              >
                <td>{{ item.matterName }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.readOnly ? "系统" : "手动" }}</td>
                <td>
                  <span
                    style="color: #fd7e2d"
                    @click="$dialog.alert({ message: item.remark })"
                    >查看</span
                  >
                </td>
              </tr>
              <tr>
                <td>应收合计</td>
                <td>{{ receivableAll }}元</td>
                <td></td>
                <td></td>
              </tr>
            </table>
          </div>
          <div class="card">
            <div class="title">应付事项</div>
            <table class="table">
              <tr class="head">
                <td>费用类型</td>
                <td>金额</td>
                <td>生成方式</td>
                <td>
                  <span>操作</span>
                </td>
              </tr>
              <tr
                v-for="(item, index) in returnOrderDetail.payableOrderItems"
                :key="index"
              >
                <td>{{ item.matterName }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.readOnly ? "系统" : "手动" }}</td>
                <td>
                  <span
                    style="color: #fd7e2d"
                    @click="$dialog.alert({ message: item.remark })"
                    >查看</span
                  >
                </td>
              </tr>
              <tr>
                <td>应付合计</td>
                <td>{{ payableAll }}元</td>
                <td></td>
                <td></td>
              </tr>
            </table>
          </div>
          <div class="card">
            <div class="title" v-if="payableAll - receivableAll > 0">
              应付：{{ payableAll }} - {{ receivableAll }} =
              {{ accSub(payableAll, receivableAll) }}
            </div>
            <div class="title" v-else>
              应收：{{ receivableAll }} - {{ payableAll }} =
              {{ accSub(receivableAll, payableAll) }}
            </div>
          </div>
          <div class="card">
            <div class="title" @click="orderI = !orderI">
              所有账单
              <span class="icon">
                <i
                  class="iconfont"
                  :class="orderI ? 'iconjian' : 'icontianjia'"
                ></i>
              </span>
            </div>
            <div v-show="orderI">
              <div
                class="orderBody"
                v-for="(
                  orderItems, index
                ) in returnOrderDetail.contractOrderList"
                :key="index"
              >
                <div>
                  <div class="orderBody-body blod">
                    <div class="name">{{ orderItems.orderName }}</div>
                    <div :class="orderItems.status == '3' ? 'success' : 'fail'">
                      {{
                        orderItems.status == "1"
                          ? "未支付"
                          : orderItems.status == "2"
                          ? "部分支付"
                          : orderItems.status == "3"
                          ? "已支付"
                          : ""
                      }}
                    </div>
                  </div>
                  <div class="orderBody-body">
                    租期：{{
                      orderItems.startDate
                        ? orderItems.startDate.slice(0, 10)
                        : ""
                    }}
                    到
                    {{
                      orderItems.endDate ? orderItems.endDate.slice(0, 10) : ""
                    }}
                  </div>
                  <div class="orderBody-head">
                    <div>
                      <p class="name">账单金额</p>
                      <p class="text">￥{{ orderItems.copeAmount }}</p>
                    </div>
                    <div class="line"></div>
                    <div>
                      <p class="name">已付金额</p>
                      <p class="text">￥{{ orderItems.actualAmount }}</p>
                    </div>
                    <div class="line"></div>
                    <div>
                      <p class="name">账单日期</p>
                      <p class="text">
                        {{
                          orderItems.expireDate
                            ? orderItems.expireDate.slice(0, 10)
                            : ""
                        }}
                      </p>
                    </div>
                  </div>
                  <div
                    :class="orderItems.detailShow ? '' : 'border-b'"
                    class="orderBody-body"
                  >
                    <div class="name">
                      <!-- <span v-if="orderItems.unpaidAmount/1<0">待收款金额</span> -->
                      <span>未支付金额</span>&emsp;
                      <span class="money"
                        >￥{{
                          accSub(orderItems.copeAmount, orderItems.actualAmount)
                        }}</span
                      >
                    </div>
                    <div
                      class="text"
                      @click.stop="
                        orderItems.detailShow = !orderItems.detailShow
                      "
                    >
                      费用明细
                      <span>
                        <i
                          v-if="!orderItems.detailShow"
                          class="iconfont iconxiala"
                        ></i>
                        <i
                          v-if="orderItems.detailShow"
                          class="iconfont iconxiangshang"
                        ></i>
                      </span>
                    </div>
                  </div>
                  <div class="details" v-if="orderItems.detailShow">
                    <div
                      v-for="(detail, index) in orderItems.orderItemList"
                      :key="index"
                    >
                      <div class="name">{{ detail.matterName }}</div>
                      <div>￥{{ detail.copeAmount }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <van-tabs value="1">
              <van-tab title="水电燃账单">
                <div
                  class="orderBody"
                  v-for="(orderItems, index) in returnOrderDetail.wegOrders"
                  :key="index"
                >
                  <div>
                    <div class="orderBody-body blod">
                      <div class="name">{{ orderItems.orderName }}</div>
                      <div
                        :class="orderItems.status == '3' ? 'success' : 'fail'"
                      >
                        {{
                          orderItems.status == "1"
                            ? "未支付"
                            : orderItems.status == "2"
                            ? "部分支付"
                            : orderItems.status == "3"
                            ? "已支付"
                            : ""
                        }}
                      </div>
                    </div>
                    <div class="orderBody-body">
                      租期：{{
                        orderItems.startDate
                          ? orderItems.startDate.slice(0, 10)
                          : ""
                      }}
                      到
                      {{
                        orderItems.endDate
                          ? orderItems.endDate.slice(0, 10)
                          : ""
                      }}
                    </div>
                    <div class="orderBody-head">
                      <div>
                        <p class="name">账单金额</p>
                        <p class="text">￥{{ orderItems.copeAmount }}</p>
                      </div>
                      <div class="line"></div>
                      <div>
                        <p class="name">已付金额</p>
                        <p class="text">￥{{ orderItems.actualAmount }}</p>
                      </div>
                      <div class="line"></div>
                      <div>
                        <p class="name">账单日期</p>
                        <p class="text">
                          {{
                            orderItems.expireDate
                              ? orderItems.expireDate.slice(0, 10)
                              : ""
                          }}
                        </p>
                      </div>
                    </div>
                    <div
                      :class="orderItems.detailShow ? '' : 'border-b'"
                      class="orderBody-body"
                    >
                      <div class="name">
                        <!-- <span v-if="orderItems.unpaidAmount/1<0">待收款金额</span> -->
                        <span>未支付金额</span>&emsp;
                        <span class="money"
                          >￥{{
                            accSub(
                              orderItems.copeAmount,
                              orderItems.actualAmount
                            )
                          }}</span
                        >
                      </div>
                      <div
                        class="text"
                        @click.stop="
                          orderItems.detailShow = !orderItems.detailShow
                        "
                      >
                        费用明细
                        <span>
                          <i
                            v-if="!orderItems.detailShow"
                            class="iconfont iconxiala"
                          ></i>
                          <i
                            v-if="orderItems.detailShow"
                            class="iconfont iconxiangshang"
                          ></i>
                        </span>
                      </div>
                    </div>
                    <div class="details" v-if="orderItems.detailShow">
                      <div
                        v-for="(detail, index) in orderItems.orderItemList"
                        :key="index"
                      >
                        <div class="name">{{ detail.matterName }}</div>
                        <div>￥{{ detail.copeAmount }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </van-tab>
            </van-tabs>
          </div>
        </div>
      </van-tab>
      <van-tab title="退租账单">
        <div
          v-for="(orderItems, index) in returnOrderDetail.returnOrders"
          :key="index"
        >
          <div class="orderBody">
            <div class="orderBody-body blod">
              <div class="name">{{ orderItems.orderName }}</div>
              <div :class="orderItems.status == '3' ? 'success' : 'fail'">
                {{
                  orderItems.status == "1"
                    ? "未支付"
                    : orderItems.status == "2"
                    ? "部分支付"
                    : orderItems.status == "3"
                    ? "已支付"
                    : ""
                }}
              </div>
            </div>
            <div class="orderBody-body">
              租期：{{
                orderItems.startDate ? orderItems.startDate.slice(0, 10) : ""
              }}
              到 {{ orderItems.endDate ? orderItems.endDate.slice(0, 10) : "" }}
            </div>
            <div class="orderBody-head">
              <div>
                <p class="name">账单金额</p>
                <p class="text">￥{{ orderItems.copeAmount }}</p>
              </div>
              <div class="line"></div>
              <div>
                <p class="name">已付金额</p>
                <p class="text">￥{{ orderItems.actualAmount }}</p>
              </div>
              <div class="line"></div>
              <div>
                <p class="name">账单日期</p>
                <p class="text">
                  {{
                    orderItems.expireDate
                      ? orderItems.expireDate.slice(0, 10)
                      : ""
                  }}
                </p>
              </div>
            </div>
            <div
              :class="orderItems.detailShow ? '' : 'border-b'"
              class="orderBody-body"
            >
              <div class="name">
                <!-- <span v-if="orderItems.unpaidAmount/1<0">待收款金额</span> -->
                <span>未支付金额</span>&emsp;
                <span class="money"
                  >￥{{
                    accSub(orderItems.copeAmount, orderItems.actualAmount)
                  }}</span
                >
              </div>
              <div
                class="text"
                @click.stop="orderItems.detailShow = !orderItems.detailShow"
              >
                费用明细
                <span>
                  <i
                    v-if="!orderItems.detailShow"
                    class="iconfont iconxiala"
                  ></i>
                  <i
                    v-if="orderItems.detailShow"
                    class="iconfont iconxiangshang"
                  ></i>
                </span>
              </div>
            </div>
            <div class="details" v-if="orderItems.detailShow">
              <div
                v-for="(detail, index) in orderItems.orderItemList"
                :key="index"
              >
                <div class="name">{{ detail.matterName }}</div>
                <div>￥{{ detail.copeAmount }}</div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab
        v-if="returnOrderDetail.returnOrderImage.delivery"
        title="退租交接单"
      >
        <div v-if="returnOrderDetail.returnOrderImage.delivery">
          <div class="imgBody">
            <div class="imgCard">
              <!-- <div class="text">退租交接单</div> -->
              <div
                class="img"
                @click="
                  imgShow = true;
                  imgIndex = 0;
                  images = [returnOrderDetail.returnOrderImage.delivery];
                "
              >
                <van-image
                  width="3rem"
                  height="3rem"
                  :src="returnOrderDetail.returnOrderImage.delivery"
                />
              </div>
              <!-- <div class="text">退租交接单</div> -->
            </div>
          </div>
        </div>
      </van-tab>

      <div
        v-if="
          returnOrderDetail.returnOrderStatus == 1 ||
          returnOrderDetail.returnOrderStatus == 2 ||
          returnOrderDetail.returnOrderStatus == 3 ||
          returnOrderDetail.returnOrderStatus == 4
        "
        style="height: 1.2rem"
      ></div>
    </van-tabs>
    <div class="btn" v-if="!$route.query.type">
        <van-button
        v-if="
          (returnOrderDetail.returnOrderStatus == 1 || returnOrderDetail.returnOrderStatus == 3) &&
              (returnOrderDetail.caStatus == 1 || !returnOrderDetail.caStatus)&&
          $store.state.buttonAuth.indexOf('crm_returnContractFddCA') > -1
        "
        type="primary"
        @click="checkSign();"
        >去签署</van-button
      >
  
      <van-button
        v-if="
          (returnOrderDetail.returnOrderStatus == 1 ||
            returnOrderDetail.returnOrderStatus == 3) &&
          $store.state.buttonAuth.indexOf('crm_returnOrderChange') > -1
        "
        type="primary"
        @click="
          $router.push({
            path: 'returnOrderAdd',
            query: { id: returnOrderDetail.id },
          })
        "
        >修改</van-button
      >
      <van-button
        v-if="returnOrderDetail.returnOrderStatus == 1"
        type="primary"
        @click="refreshReturn"
        >刷新</van-button
      >
      <van-button
        v-if="
          (returnOrderDetail.returnOrderStatus == 1 ||
            returnOrderDetail.returnOrderStatus == 3) &&
              (returnOrderDetail.caStatus == 3 || returnOrderDetail.caStatus == 4)&&
          $store.state.buttonAuth.indexOf('crm_returnOrderSubmit') > -1
        "
        type="primary"
        :loading="submitLoading"
        @click="submitReturn"
        >提交</van-button
      >
       <van-button
            v-if="
              $store.state.buttonAuth.indexOf('crm_returnContractRecallFddCA') >
                -1 &&
              (returnOrderDetail.returnOrderStatus == 1 || returnOrderDetail.returnOrderStatus == 3) &&
              (returnOrderDetail.caStatus == 2 ||returnOrderDetail.caStatus == 4 ) && returnOrderDetail.quitType != 7
            "
            type="primary"
          
             :loading="recallLoad"
            @click="
             recall
            "
            >撤销</van-button
          >
      <van-button
        v-if="
          returnOrderDetail.returnOrderStatus > 1 &&
          returnOrderDetail.houseType == 1 &&
          $store.state.buttonAuth.indexOf('crm_returnOrderSend') > -1
        "
        type="primary"
        @click="cleanShow = true"
        >退租保洁</van-button
      >
      <van-button
        v-if="
          returnOrderDetail.returnOrderStatus == 1 &&
          returnOrderDetail.quitType !== 7 &&
          returnOrderDetail.quitType !== 8 &&
          returnOrderDetail.quitType !== 9 &&
              (!returnOrderDetail.caStatus || returnOrderDetail.caStatus == 1)&&
          $store.state.buttonAuth.indexOf('crm_returnOrderCancel') > -1
        "
        type="primary"
        @click="cancel"
        >作废</van-button
      >
       <van-button
        v-if="
        
              (returnOrderDetail.caStatus == 3)&&
          $store.state.buttonAuth.indexOf('crm_returnContractFddCADownload') > -1
        "
         :loading="downloadFddLoad"
        :disabled="downloadFddLoad"
        type="primary"
        @click="returnContractDownFddload"
        >下载</van-button
      >
      <van-button
        v-if="
          returnOrderDetail.returnOrderStatus == 4 ||
          returnOrderDetail.returnOrderStatus == 3 ||
          returnOrderDetail.returnOrderStatus == 2
        "
        type="primary"
        @click="
          $router.push({
            path: 'approval',
            query: { businessId: returnOrderDetail.id },
          })
        "
        >查看审批</van-button
      >
    </div>
    <!-- 审批 -->
    <van-steps
      direction="vertical"
      :active="0"
      active-color="#FD7E2D"
      active-icon="more"
      inactive-icon="checked"
      v-if="type == 1"
    >
      <van-step v-for="item in trackRecordList" :key="item.id">
        <!-- 开始 -->
        <div v-if="item.taskStartEndType == 1">
          <div v-for="(item1, index1) in item.actors" :key="index1">
            <h4>{{ item1.actorName }}</h4>
            <p v-if="item.actorTime">发起时间：{{ item.actorTime }}</p>
          </div>
        </div>
        <!-- 审批 -->
        <div v-else-if="item.taskType == 1">
          <div v-for="(item1, index1) in item.actors" :key="index1">
            <h4>{{ item1.actorName }}</h4>
            <p v-if="item1.approvalStatus">
              审批结果：{{ approvalStatusList[item1.approvalStatus - 1] }}
            </p>
            <p v-if="item1.remark">审批意见：{{ item1.remark }}</p>
            <p v-if="item1.approvalTime">处理时间：{{ item1.approvalTime }}</p>
            <p v-if="item1.createTime">到达时间：{{ item1.createTime }}</p>
          </div>
        </div>
        <!-- 抄送 -->
        <div v-else-if="item.taskType == 2">
          <div>
            <h4>
              <span v-for="(item1, index1) in item.actors" :key="index1">
                <span v-if="index1 != 0">/</span>
                {{ item1.actorName }}
              </span>
            </h4>
            <p v-if="item.actors[0] ? item.actors[0].createTime : ''">
              到达时间：{{ item.actors[0] ? item.actors[0].createTime : "" }}
            </p>
          </div>
        </div>
        <!-- 结束 -->
        <div v-else>结束</div>
        <!-- <h4>
          <span v-for="(item1,index1) in item.actors" :key="index1">
            <span v-if="index1!=0">/</span>
            {{item1.actorName}}
          </span>
        </h4>
        <p v-if="item.actors[0]?item.actors[0].createTime:''">到达时间：{{item.actors[0]?item.actors[0].createTime:''}}</p>-->
      </van-step>
    </van-steps>
    <van-form
      ref="form"
      label-width="110px"
      input-align="left"
      v-if="type == 1 && trackRecordList[0].status != 5"
    >
      <van-field label="审批意见" :border="false" />
      <van-field
        v-model="formData.remark"
        rows="2"
        autosize
        type="textarea"
        maxlength="50"
        placeholder="请输入审批意见"
        show-word-limit
        :rules="[{ required: true, message: '请输入审批意见' }]"
      />
    </van-form>
    <div class="btn" v-if="$route.query.type">
      <van-button v-if="type == 0" @click="type = 1" type="primary"
        >审批</van-button
      >
      <van-button v-if="type == 1" @click="type = 0" type="primary"
        >详情</van-button
      >
      <van-button
        block
        type="primary"
        v-if="type == 1 && trackRecordList[0].status != 5"
        :loading="saveLoad"
        :disabled="saveLoad"
        @click="submit(2)"
        >驳回</van-button
      >
      <van-button
        block
        type="primary"
        v-if="type == 1 && trackRecordList[0].status != 5"
        :loading="saveLoad"
        :disabled="saveLoad"
        @click="submit(1)"
        >同意</van-button
      >
    </div>
    <!-- 作废弹框 -->
    <!-- <van-dialog v-model="showCancel" title="合约作废" show-cancel-button :before-close="cancel">
      <van-form ref="cancelForm">
        <div style="padding:0.4rem;color:#323232;text-align:left">作废原因</div>
        <van-field
          v-model="cancelRemark"
          type="textarea"
          name="用户名"
          placeholder="请输入作废原因"
          rows="2"
          maxlength="50"
          autosize
          :rules="[{ required: true, message: '请填写作废原因' }]"
        />
      </van-form>
    </van-dialog>-->
    <van-image-preview
      v-model="imgShow"
      :startPosition="imgIndex"
      :images="images"
    ></van-image-preview>
    <!-- 加载 -->
    <div class="loading" v-if="loading"></div>
    <!-- 退租保洁 -->
    <van-dialog
      v-model="cleanShow"
      title="退租保洁"
      show-cancel-button
      :before-close="cleanSubmit"
    >
      <van-form ref="cleanForm" input-align="left" class="dialogForm">
        <van-field
          name="checkbox"
          label="保洁房间"
          v-if="returnOrderDetail.rentType == 1"
        >
          <template #input>
            <!-- <van-checkbox v-model="cleanQuery.isOverClean" shape="square" /> -->
            <van-radio-group
              v-model="cleanQuery.isOverClean"
              direction="horizontal"
            >
              <van-radio :name="1">全部</van-radio>
              <van-radio :name="0">单个</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <div class="field van-cell--required">完工前照片</div>
        <div class="body body1">
          <van-uploader
            :before-read="beforeRead"
            :after-read="
              (item) => {
                preImageList.pop();
                preImageList.push({
                  url: upload_qiniu_addr + item.file.key,
                  isImage: true,
                });
              }
            "
            v-model="preImageList"
            :max-count="10"
          />
          <van-field
            name="preImageList"
            disabled
            :rules="[
              {
                validator: (item) => {
                  return Boolean(preImageList.length);
                },
                message: '请上传完工前图片',
              },
            ]"
          />
        </div>
        <van-field
          v-model="cleanQuery.remark"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          placeholder="请输入备注"
          show-word-limit
        />
      </van-form>
    </van-dialog>
    <!-- 去签署 -->
     <van-dialog
      v-model="caShow"
      title="签署电子退租单"
      show-cancel-button
      :before-close="caSubmit"
    >
      <van-form ref="caForm" input-align="left" class="dialogForm">
        <van-field
          name="checkbox"
          label="签署类型"
           :rules="[
              {
                validator: (item) => {
                  return Boolean(caQuery.type);
                },
                message: '请勾选签署类型',
              },
            ]"
        >
          <template #input>
            <!-- <van-checkbox v-model="cleanQuery.isOverClean" shape="square" /> -->
            <van-radio-group
              v-model="caQuery.type"
              direction="horizontal"
            
            >
              <van-radio :disabled="goCA" :name="1">去签署</van-radio>
              <van-radio :name="2">不签署</van-radio>
            </van-radio-group>
          </template>
        </van-field>
       
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  requestCReturnDetail,
  requestReturnSubmit,
  requestReturnCancel,
  requestWorkflowDetail1,
  requestWorkflowSubmit,
  requestSubmitValid,
  requestSubmitRefresh,
  requestWorkOrderISClean,
  requestQiniuToken,
  changeCompany, //钉钉消息进入详情页需切换公司 获取对应按钮权限
  requestButtomAuth,
   requestHouseWaterExist,
  requestHouseElectronicExist,
  requestHouseWaterIsRight,
  requestHouseElectronicIsRight,
  requestReturnOrderCa,
  requestReturnOrderDownLoad,
  requestHouseSettlement, //校验房源当天有没有结算水电费
  requestReturnRecallCa,
  requestReturnOrderCaCheck
} from "@/api";
import { compress, compressAccurately } from "image-conversion";
import request from "@/utils/request";
import { mergeRowCol, accAdd, accSub, formatDate } from "@/utils/index";
export default {
  name: "returnOrderDetail",
  data() {
    return {
      active: 0,
      returnOrderDetail: {
        contractOrderList: [],
        returnOrderImage: {},
        otherList: [],
      },
      receivableAll: 0,
      payableAll: 0,
      orderI: false,
      // showCancel: false,
      // cancelRemark: "",
      imgIndex: 0,
      images: [],
      imgShow: false,
      //审批
      type: 0, //切换0.详情/1.审批
      saveLoad: false,
      trackRecordList: [{ status: "" }],
      processTypeList: ["", "收房合约", "租房合约", "收房退租", "租房退租"],
      statusList: ["", "审批中", "已完成", "取消", "挂起"],
      loading: true,
      formData: {
        remark: "",
      },
      //退租保洁
      cleanShow: false,
      cleanQuery: {
        returnOrderId: "",
        isOverClean: 0,
        preImageList: [],
        remark: "",
      },
      caQuery:{
        returnOrderId:"",
        type:""
      },
      goCA:false,
      preImageList: [],
      qiniuData: {},
      caShow:false,
      downloadFddLoad:false,
      submitLoading:false,
        showWaterModel: "",
      showElectronicModel: "",
        waterSubmit: "",
      ElectronicSubmit: "",
      goSettlement:"",
      recallLoad:false
    };
  },
  computed: {
    ...mapState([
      "idTypeList",
      "destineList",
      "payList",
      "contractList",
      "customerList",
      "quitTypeList",
      "returnOrderStatus",
      "payTypeList",
      "approvalStatusList",
      "upload_qiniu_addr",
      "caStatusList"
    ]),
  },
  created() {
    this.getDetail();
    this.getQiniuToken();
    if (this.$route.query.type) {
      //待办进入
      this.getWorkflow();
    }
  },
  mounted() {},
  methods: {
    getDetail() {
      const toast1 = this.$toast.loading({
        forbidClick: true,
        duration: 0,
        message: "加载中...",
      });
      requestCReturnDetail(this.$route.query.id)
        .then((res) => {
          changeCompany({ companyId: res.data.companyId }).then((res) => {
            this.$store.dispatch("resetAll", res.data);
            requestButtomAuth().then((res) => {
              this.$store.commit("SET_BUTTON", res.data || []);
            });
          });
          res.data.returnOrderImage = res.data.returnOrderImage || {};
          res.data.contractOrderList = res.data.contractOrderList || [];
          res.data.contractOrderList.forEach((d) => {
            d.detailShow = false;
          });
          res.data.wegOrders = res.data.wegOrders || [];
          res.data.wegOrders.forEach((d) => {
            d.detailShow = false;
          });
          res.data.returnOrders = res.data.returnOrders || [];
          res.data.returnOrders.forEach((d) => {
            d.detailShow = false;
          });
          let receivableAll = 0;
          let payableAll = 0;
          res.data.receivableOrderItems.forEach((d) => {
            receivableAll = accAdd(receivableAll, d.amount / 1);
          });
          res.data.payableOrderItems.forEach((d) => {
            payableAll = accAdd(payableAll, d.amount / 1);
          });
          this.receivableAll = receivableAll;
          this.payableAll = payableAll;
          let otherList = [];
          if (res.data.returnOrderImage) {
            (res.data.returnOrderImage.other || "").split(";").forEach((d) => {
              otherList.push(d);
            });
          }
          res.data.otherList = otherList;
          this.returnOrderDetail = res.data;

          this.loading = false;
          toast1.clear();
        })
        .catch((err) => {
          toast1.clear();
        });
    },
    //查流程
    getWorkflow() {
      //审批待办
      requestWorkflowDetail1(this.$route.query.agentId).then((res) => {
        this.trackRecordList = res.data ? res.data : [];
        this.trackRecordList[0].status == 5 ? (this.type = 1) : (this.type = 0);
        // this.loading = false;
      });
    },
    //刷新
    refreshReturn() {
      requestSubmitRefresh(this.returnOrderDetail.id).then((res) => {
        this.getDetail();
      });
    },
      // 根据房源判断绑定关系是否存在 水表
    async getHouseWaterExist() {
      console.log(this.returnOrderDetail);
      let checkRoom = this.returnOrderDetail.rentType - 1;
      return requestHouseWaterExist(this.returnOrderDetail.houseId, checkRoom)
        .then((res) => {
          this.showWaterModel = !res.data;
          return res;
        })
        .catch((err) => {});
    },
    // 根据房源判断绑定关系是否存在 电表
    async getHouseElectronicExist() {
      console.log(this.returnOrderDetail);
      let checkRoom = this.returnOrderDetail.rentType - 1;
      return requestHouseElectronicExist(this.returnOrderDetail.houseId, checkRoom)
        .then((res) => {
          this.showElectronicModel = !res.data;
          return res;
        })
        .catch((err) => {});
    },
    // 根据房源判断绑定关系是否正确 水表
    getHouseWaterExistIsRight() {
      let checkRoom = this.returnOrderDetail.rentType - 1;
      requestHouseWaterIsRight(this.returnOrderDetail.houseId, checkRoom)
        .then((res) => {
          this.waterSubmit = res.data;
        })
        .catch((err) => {});
    },
    // 根据房源判断绑定关系是否正确 电表
    getHouseElectronicExistIsRight() {
      let checkRoom = this.returnOrderDetail.rentType - 1;
      requestHouseElectronicIsRight(this.returnOrderDetail.houseId, checkRoom)
        .then((res) => {
          this.ElectronicSubmit = res.data;
        })
        .catch((err) => {});
    },
    getHouseSettlement() {
      return new Promise((resolve, reject) => {
        requestHouseSettlement(this.returnOrderDetail.contractId).then((res) => {
          if (res) {
            this.goSettlement = res.data;
            resolve(res);
          }
        });
      });
    },
    async validEquip() {
      return Promise.all([
        await this.getHouseWaterExist(),
        await this.getHouseElectronicExist(),
      ])
        .then(async (result) => {
          if (!this.showWaterModel || !this.showElectronicModel) {
            let wData = await this.getHouseWaterExistIsRight();
            let eData = await this.getHouseElectronicExistIsRight();
            if (this.waterSubmit != 0) {
              this.$toast.fail(
                `当前合同所关联的${
                  this.returnOrderDetail.rentType > 1 ? "房源" : "房间"
                }【智能水表】设备绑定关系不正确，无法提交，联系运营部负责人，在该房源上重新操作设备绑定后再提交`
              );
              return false;
            }
            if (this.ElectronicSubmit != 0) {
              this.$toast.fail(
                `当前合同所关联的${
                  this.returnOrderDetail.rentType > 1 ? "房源" : "房间"
                }【智能电表】设备绑定关系不正确，无法提交，联系运营部负责人，在该房源上重新操作设备绑定后再提交`
              );
              return false;
            }
          }

          if (
            (!this.showWaterModel || !this.showElectronicModel) &&
            !this.waterSubmit &&
            !this.ElectronicSubmit
          ) {
            let s = await this.getHouseSettlement();

            if (this.goSettlement == 0) {
              console.log("Resrt")
              this.$dialog.confirm({
                title: "提示",
                message: `该${
                  this.returnOrderDetail.rentType > 1 ? "房源" : "房间"
                }当天没有结算水电费，请到${
                  this.returnOrderDetail.rentType > 1 ? "房源" : "房间"
                }列表进行抄表，待结算成功之后再提交`,
                confirmButtonText: "去抄表",
                cancelButtonText: "取消",
               
              }).then(()=>{
                 this.saveLoad = true;
                    this.$router.push({
                      path: `/roomList`,
                      query:{
                        address:this.returnOrderDetail.houseAddress
                      }
                    });
                    this.saveLoad = false;
              }).catch(err=>{
                return false
              });

              return false;
            }
            if (this.goSettlement == 2) {
              this.$toast.success("结算任务已提交!");
              this.saveLoad = false;
              return false;
            }
             return true
          }
           return true
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //提交
    async submitReturn() {
        this.submitLoading = true
      //      let result = await this.validEquip();
      // console.log(result)
      // if (!result) {
      //   this.submitLoading = false;
      //   return false;
      // }
      this.$dialog.confirm({
        title: "提示",
        message: "请确认退租信息填写是否正确！",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickOverlay: true,
        beforeClose: (action, done) => {
          console.log(action);
          if (action == "confirm") {
            requestSubmitValid(this.returnOrderDetail.id)
              .then((res) => {
                requestReturnSubmit(this.returnOrderDetail.id)
                  .then((res) => {
                    this.$toast({
                      type: "success",
                      message: "提交成功!",
                    });
                      this.submitLoading = false;
                    done();
                    this.getDetail();
                  })
                  .catch((err) => {
                      this.submitLoading = false;
                    console.log(err);
                    done(false);
                  });
              })
              .catch((err) => {
                  this.submitLoading = false;
                done(false);
              });
          } else {
              this.submitLoading = false;
            done();
          }
        },
      });
    },
     async recall() {
        this.recallLoad = true
      //      let result = await this.validEquip();
      // console.log(result)
      // if (!result) {
      //   this.submitLoading = false;
      //   return false;
      // }
      this.$dialog.confirm({
        title: "提示",
        message: "请确认是否撤销签署!",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickOverlay: true,
        beforeClose: (action, done) => {
          console.log(action);
          if (action == "confirm") {
            requestReturnRecallCa(this.returnOrderDetail.id)
              .then((res) => {
                  this.$toast({
                      type: "success",
                      message: "撤销成功!",
                    });
                      this.recallLoad = false;
                    done();
                    this.getDetail();
              })
              .catch((err) => {
                  this.recallLoad = false;
                done(false);
              });
          } else {
              this.recallLoad = false;
            done();
          }
        },
      });
    },
      checkSign(){
      requestReturnOrderCaCheck(this.returnOrderDetail.id).then(res=>{
        console.log(res)
        if(res){
           this.goCA = !res.data
          this.caShow = true 
        }
       
      }).catch(err=>{

      })
    },
    //退租保洁
    //获取七牛token
    getQiniuToken() {
      requestQiniuToken()
        .then((res) => {
          this.qiniuData.token = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //图片上传前校验，压缩
    beforeRead(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isLt8M = file.size / 1024 / 1024 < 8;
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isJPG && !isPNG) {
        this.$toast.fail("图片只能是 JPG/PNG 格式！");
        return false;
      }
      if (!isLt10M) {
        this.$toast.fail("图片大小不能超过 10MB!");
        return false;
      }
      this.qiniuData.key = Date.now() + file.name;
      return new Promise((resolve, reject) => {
        compressAccurately(file, 400).then((fileMin) => {
          let data = new FormData();
          data.append("token", this.qiniuData.token);
          data.append("key", this.qiniuData.key);
          data.append("file", fileMin);
          request({
            url: this.$store.state.qiniuUpload,
            method: "post",
            processData: false,
            headers: {
              "Content-Type": "multipart/form-data",
            },
            data: data,
          })
            .then((res) => {
              let newFile = fileMin;
              newFile.key = res.key;
              resolve(newFile);
            })
            .catch((err) => {
              console.log(err);
              reject(err);
            });
        });
      });
    },
    cleanSubmit(action, done) {
      if (action === "confirm") {
        this.$refs.cleanForm
          .validate()
          .then((valid) => {
            this.cleanQuery.returnOrderId = this.returnOrderDetail.id;
            this.cleanQuery.preImageList = [];
            this.preImageList.forEach((d) => {
              this.cleanQuery.preImageList.push(d.url);
            });
            this.cleanQuery.isOverClean =
              this.returnOrderDetail.rentType == 1
                ? this.cleanQuery.isOverClean
                : null;
            requestWorkOrderISClean(this.cleanQuery)
              .then((res) => {
                this.$toast.success({
                  message: "成功！",
                  forbidClick: true,
                  onClose: () => {
                    this.getDetail();
                    done();
                    this.cleanQuery = {
                      returnOrderId: "",
                      isOverClean: 0,
                      preImageList: [],
                      remark: "",
                    };
                    this.preImageList = [];
                  },
                });
              })
              .catch((err) => {
                done();
              });
          })
          .catch((err) => {
            done(false);
          });
      } else {
        this.cleanQuery = {
          returnOrderId: "",
          isOverClean: 0,
          preImageList: [],
          remark: "",
        };
        this.preImageList = [];
        done();
      }
    },
    caSubmit(action, done) {
      if (action === "confirm") {
        this.$refs.caForm
          .validate()
          .then((valid) => {
            // this.caQuery.returnOrderId = this.returnOrderDetail.id;
           
            requestReturnOrderCa(this.returnOrderDetail.id,this.caQuery.type)
              .then((res) => {
                this.$toast.success({
                  // message: "",
                  forbidClick: true,
                  onClose: () => {
                    this.getDetail();
                    done();
                    this.caQuery = {
                      returnOrderId: "",
                      type: "",
                     
                    };
                  },
                });
              })
              .catch((err) => {
                done();
              });
          })
          .catch((err) => {
            done(false);
          });
      } else {
        this.caQuery = {
          returnOrderId: "",
          type: "",
         
        };
        done();
      }
    },
      copyShaneUrl(shareLink) {
      // var input = document.createElement("input");   // 直接构建input
      // input.value = shareLink;  // 设置内容
      // document.body.appendChild(input);    // 添加临时实例
      // input.select();   // 选择实例内容
      // document.execCommand("Copy");   // 执行复制
      // document.body.removeChild(input); // 删除临时实例

      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        const range = document.createRange();
        range.selectNode(
          document.getElementsByClassName("van-dialog__message")[0]
        );
        const selection = window.getSelection();
        if (selection.rangeCount > 0) selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand("copy");
        // alert("复制成功")
      } else {
        var input = document.createElement("input"); // 直接构建input
        input.value = shareLink; // 设置内容
        document.body.appendChild(input); // 添加临时实例
        input.select(); // 选择实例内容
        document.execCommand("Copy"); // 执行复制
        document.body.removeChild(input); // 删除临时实例
      }
    },
     returnContractDownFddload() {
      this.downloadFddLoad = true;
      requestReturnOrderDownLoad(this.returnOrderDetail.id)
        .then(async (res) => {
          console.log(res);
          this.$dialog
            .alert({
              title: "请复制内容在浏览器打开",
              message: `${res.data}`,
              confirmButtonText: "复制",
            })
            .then(() => {
              this.copyShaneUrl(res.data);
              this.$toast.success("复制成功");
              this.downloadFddLoad = false;
            });
         
        })
        .catch((err) => {
          this.downloadFddLoad = false;
        });
    },
    cancel() {
      this.$dialog.confirm({
        title: "提示",
        message: "确认作废",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, done) => {
          if (action === "confirm") {
            requestReturnCancel(this.returnOrderDetail.id)
              .then((res) => {
                this.$toast({
                  type: "success",
                  message: "作废成功!",
                });
                this.getDetail();
                done();
              })
              .catch((err) => {
                console.log(err);
                done(false);
              });
          } else {
            done();
          }
        },
      });
    },
    accSub(num1, num2) {
      return accSub(num1, num2);
    },
    //审批提交
    submit(type) {
      let param = {
        agentId: this.$route.query.agentId,
        orderId: this.$route.query.orderId,
        approvalStatus: type,
        remark: this.formData.remark,
      };
      if (type == 1) {
        //同意
        this.$dialog.confirm({
          title: "提示",
          message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          beforeClose: (action, done) => {
            if (action === "confirm") {
              this.saveLoad = true;
              requestWorkflowSubmit(param)
                .then((res) => {
                  this.$toast.success("审批成功");
                  this.getWorkflow();
                  this.saveLoad = false;
                  done();
                })
                .catch((err) => {
                  this.saveLoad = false;
                  done(false);
                });
            } else {
              done();
            }
          },
        });
      } else {
        //驳回
        this.$refs["form"].validate().then((valid) => {
          this.$dialog.confirm({
            title: "提示",
            message: type == 1 ? "确定同意吗？" : "确定驳回吗？",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            beforeClose: (action, done) => {
              if (action === "confirm") {
                this.saveLoad = true;
                requestWorkflowSubmit(param)
                  .then((res) => {
                    this.$toast.success("审批成功");
                    this.getWorkflow();
                    this.saveLoad = false;
                    done();
                  })
                  .catch((err) => {
                    this.saveLoad = false;
                    done(false);
                  });
              } else {
                done();
              }
            },
          });
        });
      }
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
#returnOrderDetail {
  .colorC {
    color: $colorC;
  }
  .theme-color {
    color: $theme-color;
  }
  .titlee {
    padding: 0.2rem 0;
    background-color: #fff;
    font-size: 0.3rem;
  }
  .content {
    background-color: #fff;
    display: flex;
    // border-radius: 0.2rem;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    &.nowarp {
      flex-wrap: nowrap;
    }
    .inlineB {
      flex: 1;
      padding: 0.2rem 0;
      width: 33.3%;
      min-width: 33.3%;
      max-width: 33.3%;
      p.l {
        line-height: 0.7rem;
        height: 0.7rem;
      }
    }
  }
  .tabs {
    .title {
      text-align: left;
      padding: 0.3rem 0.2rem;
      font-weight: 600;
      font-size: 0.37rem;
    }
    /deep/.van-tabs__wrap {
      margin: 0.2rem 0 0;
    }
    /deep/.van-tabs__content {
      height: calc(100vh - 4.3rem);
      overflow: scroll;
    }
    .van-steps {
      text-align: left;
      padding-left: 2rem;
      /deep/.van-step__title {
        padding-left: 0.3rem;
        p {
          padding-top: 0.2rem;
        }
      }
    }
    .orderBody {
      padding: 0 0.2rem;
      // border: 2px dashed #dadada;
      font-size: 0.3rem;
      margin: 0.2rem 0;
      border-radius: 0.2rem;
      background-color: #fff;
      &:first-child {
        margin-top: 0;
      }
      .orderBody-head {
        padding: 0.2rem;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid $border-color;
        .line {
          width: 1px;
          height: 0.8rem;
          transform: translateY(0.05rem);
          background: #dadada;
        }
        .name {
        }
        .text {
          font-weight: bold;
          // color: $font-deep-gray;
        }
        p {
          padding: 0.1rem 0;
        }
      }
      .orderBody-body {
        display: flex;
        padding: 0.3rem 0;
        border-bottom: 1px solid $border-color;
        .name {
          flex: 1;
          text-align: left;
          .money {
            color: $fail-color;
          }
        }
        .success {
          color: $success-color;
        }
        .fail {
          color: $fail-color;
        }
        .pay {
          color: #fff;
          padding: 0.1rem 0.2rem;
          background: #fd7e2d;
          border-radius: 0.1rem;
        }
        .text {
          span {
            display: inline-block;
            width: 0.5rem;
          }
          i {
            font-size: 0.3rem;
          }
        }
      }
      .border-b {
        border: none !important;
      }
      .details {
        color: $font-deep-gray;
        padding: 0.2rem 0;
        > div {
          display: flex;
          padding: 0.1rem;
          .name {
            flex: 1;
            text-align: left;
          }
        }
      }
      .blod {
        font-weight: bold;
      }
    }
    .imgBody {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      background-color: #fff;
      padding: 0.5rem 0.2rem 0;
      border-radius: 0.2rem;
      .imgCard {
        .text {
          line-height: 0.8rem;
        }
      }
    }
    .imgBody.other {
      flex-wrap: wrap;
    }
    .imgBody1 {
      padding: 0 0.2rem;
    }
  }
  .btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
      margin-left: -1px;
      border: none;
      border-radius: 0;
      flex: 1;
      padding: 0%;
      &:not(:last-child)::after {
        height: 50%;
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        border-right: 0.02667rem solid #ebedf0;
        z-index: 99;
      }
    }
  }
  .form3 {
    /deep/.van-tab {
      text-align: left;
      font-weight: 600;
      .van-tab__text {
        font-size: 0.4rem;
      }
    }
    /deep/.van-tabs__content {
      height: auto;
    }
    .card {
      margin: 0.2rem 0;
      border-radius: 0.2rem;
      overflow: hidden;
    }
    .title {
      font-size: 0.4rem;
      text-align: left;
      padding: 0 0.4rem;
      font-weight: 600;
      background-color: #fff;
      line-height: 1.1rem;
      color: #fd7e2d;
      position: relative;
      .icon {
        position: absolute;
        right: 0.4rem;
      }
    }
    /deep/.van-tabs {
      .van-tabs__wrap {
        font-size: 0.4rem;
        padding: 0 0.27rem;
        background-color: #fff;
        border-radius: 0.2rem 0.2rem 0 0;
      }
    }
    .table {
      tr {
        td {
          text-align: center;
          line-height: 0.7rem;
        }
      }
      .head {
        font-weight: 600;
      }
    }
  }
  .van-steps {
    text-align: left;
    padding-left: 2rem;
    /deep/.van-step__title {
      padding-left: 0.3rem;
      p {
        padding-top: 0.2rem;
      }
    }
  }
}
.dialogForm {
  max-height: 12rem;
  overflow: auto;
  /deep/.van-field__error-message {
    text-align: left;
  }
}
.field {
  padding: 0.26667rem 0.42667rem;
  background: #fff;
  font-size: 0.32rem;
  line-height: 0.64rem;
  color: #000;
  text-align: left;
  position: relative;
  ::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 0.42667rem;
    bottom: 0;
    left: 0.42667rem;
    border-bottom: 0.02667rem solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
}
.body {
  padding: 0.1rem;
  text-align: left;
  .van-uploader {
    // margin: 0.2rem;
    /deep/.van-uploader__preview-image {
      border: 1px solid #ebedf0;
    }
  }
  .picCard {
    display: inline-block;
    margin: 0.2rem;
    width: 2.2rem;
    .text {
      text-align: center;
      .van-field {
        padding: 0;
        /deep/input {
          text-align: center;
        }
      }
    }
    .textBorder {
      /deep/.van-field__body {
        border: 1px solid $border-color;
        border-radius: 0.1rem;
        overflow: hidden;
      }
    }
  }
}
</style>
